import moment from 'moment';

export const convertToTimeZone = (dateString) => {
  const date = moment(dateString);
  if (!dateString || !date.isValid()) return null;

  const lang = localStorage.getItem('i18nextLng');
  let zone = sessionStorage.getItem('timeZone');

  if (zone && zone.length) zone = zone.substring(zone.lastIndexOf(' ') + 1);
  if (moment.tz.names().indexOf(zone) === -1) zone = moment.tz.guess();

  return date
    .tz(zone)
    .format(`${lang === 'en' ? 'MM/DD' : 'DD/MM'}/YYYY hh:mm:ss A`);
};

export const getTimeZone = () => {
  let zone = sessionStorage.getItem('timeZone');

  if (zone && zone.length) return zone.substring(zone.lastIndexOf(' ') + 1);
  if (moment.tz.names().indexOf(zone) === -1) return moment.tz.guess();
};

/**
 * Get default date range (T-7 days to today)
 * Returns { fromDate: moment object, toDate: moment object }
 */
export const getDefaultDateRange = () => {
  const today = moment().endOf('day'); // End of today (23:59:59)
  const sevenDaysAgo = moment().subtract(7, 'days').startOf('day'); // Start of 7 days ago (00:00:00)
  
  return {
    fromDate: sevenDaysAgo,
    toDate: today
  };
};

/**
 * Get date range based on preset option
 * Returns { fromDate: moment object, toDate: moment object }
 */
export const getDateRangeByPreset = (preset) => {
  const today = moment().endOf('day');
  
  switch (preset) {
    case 'today':
      return {
        fromDate: moment().startOf('day'),
        toDate: today
      };
    case 'last7days':
      return {
        fromDate: moment().subtract(7, 'days').startOf('day'),
        toDate: today
      };
    case 'last15days':
      return {
        fromDate: moment().subtract(15, 'days').startOf('day'),
        toDate: today
      };
    case 'last30days':
      return {
        fromDate: moment().subtract(30, 'days').startOf('day'),
        toDate: today
      };
    default:
      return getDefaultDateRange();
  }
};

/**
 * Format date for API with start of day time (00:00:00)
 * Returns string in format 'YYYY-MM-DD HH:mm:ss'
 */
export const formatFromDateForAPI = (date) => {
  if (!date) return '';
  return moment(date).startOf('day').format('YYYY-MM-DD HH:mm:ss');
};

/**
 * Format date for API with end of day time (23:59:59)
 * Returns string in format 'YYYY-MM-DD HH:mm:ss'
 */
export const formatToDateForAPI = (date) => {
  if (!date) return '';
  return moment(date).endOf('day').format('YYYY-MM-DD HH:mm:ss');
};



// WEBPACK FOOTER //
// ./src/utils/datetime.utils.js